module.exports = __webpack_public_path__ + "static/img/rect-tips.f744b0a2.png";